import { render } from "./TechSkills.vue?vue&type=template&id=556336ad"
import script from "./TechSkills.vue?vue&type=script&lang=js"
export * from "./TechSkills.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__